import React, {useEffect, useRef, useState} from "react";
import {ModalHandler, OpenModalHandle} from "../components/Modal/Generic/ModalHandler";
import neverLandUtils from "../utils/NeverLandUtils";
import LineupComponent from "../components/gameAnalysis/LineupComponent";
import RateComponent from "../components/gameAnalysis/RateComponent";
import RankingTable from "../components/gameAnalysis/RankingTable";
import RecentlyRecordeComponent from "../components/gameAnalysis/RecentlyRecordeComponent";
import StrengthAnalysisComponent from "../components/gameAnalysis/StrengthAnalysisComponent";
import PointGraph from "../components/gameAnalysis/PointGraph";
import OpponentRecordeComponent from "../components/gameAnalysis/OpponentRecordeComponent";
import {getFetcherAnalysis} from "../utils/fetcher_gameAnlysis";
import {GET_GAME_ANALYSIS_MENU_API, GET_STRENGTH_ANALYSIS_DATA_API} from "../constants/api_constants";
import RankingTableFromReport from "../components/gameAnalysis/RankingTableFromReport";
import StrengthAnalysisComponentFromReport from "../components/gameAnalysis/StrengthAnalysisComponentFromReport";

const BUTTON_LIST = [
  {name: "예상라인업"},
  {name: "최근전적"},
  {name: "전력분석"},
  {name: "상대전적"},
  {name: "배당률"},
  {name: "순위"},
  {name: "그래프"},
]

const GameAnalysisPage = ({
                            analysisType,
                            gameId,
                            setModalHomeTeamName,
                            setModalAwayTeamName
                          }) => {
  const OpenModal = OpenModalHandle.create();
  const [buttonList, setButtonList] = useState([]);
  const [selectedButton, setSelectedButton] = useState(""); // 선택한 버튼
  const [startX, setStartX] = useState(0);
  const [endX, setEndX] = useState(0);
  const buttonContainerRef = useRef(null); // 버튼 컨테이너 참조


  useEffect(() => {
    getAnalysisMenuList();
  }, [gameId, analysisType]);

  const handleTouchStart = (e) => {
    // 예상라인업일때 버튼영역 스와이프 안되게
    if (selectedButton.name === "예상라인업") {
      if (e.touches[0].clientY <= 200) return;
    }

    // 터치가 시작될 때 호출, 터치 시작 지점(startX) 기록
    setStartX(e.touches[0].clientX);
    setEndX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    if (startX === -1) return;
    // 화면에서 손가락을 움직일 때 호출, 현재 터치 지점(endX) 업데이트
    setEndX(e.touches[0].clientX);
  };

  // const handleTouchEnd = () => {
  //   if (startX === -1) return;
  //   // 터치영역에 따라 버튼 인덱스 추가/삭제해서 컴포넌트 변환
  //   const threshold = 50; // 스와이프 최소 거리
  //   const movementX = Math.abs(startX - endX); // 이동한 거리 계산
  //
  //   if (movementX < 10) {
  //     // 이동이 거의 없으면 클릭으로 간주하고 종료
  //     return;
  //   }
  //
  //   if (startX - endX > threshold) {
  //     // 왼쪽으로 스와이프
  //     setButtonIndex((prevIndex) =>
  //         (prevIndex + 1) % BUTTON_LIST.length
  //     );
  //   } else if (endX - startX > threshold) {
  //     // 오른쪽으로 스와이프
  //     setButtonIndex((prevIndex) =>
  //         (prevIndex - 1 + BUTTON_LIST.length) % BUTTON_LIST.length
  //     );
  //   }
  //   setStartX(-1);
  // };
  //
  // useEffect(() => {
  //   if (buttonContainerRef.current) {
  //     const container = buttonContainerRef.current;
  //
  //     if (buttonIndex <= 2) {
  //       // 앞으로 스크롤
  //       container.scrollTo({
  //         left: 0,
  //         behavior: "smooth",
  //       });
  //     } else if (buttonIndex >= BUTTON_LIST.length - 4) {
  //       // 맨 뒤로 스크롤
  //       container.scrollTo({
  //         left: container.scrollWidth,
  //         behavior: "smooth",
  //       });
  //     }
  //   }
  // }, [buttonIndex]);

  const getAnalysisMenuList = () => {
    // 버튼 메뉴 리스트 받아오기
    getFetcherAnalysis().get(GET_GAME_ANALYSIS_MENU_API + `?dataId=${gameId}&analysisType=${analysisType}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          let buttonList = data[0].menuData;
          if (responseIsSuccess) {
            setButtonList(buttonList);
            setSelectedButton(buttonList[0]);
            setModalHomeTeamName(data[0].homeTeamName);
            setModalAwayTeamName(data[0].awayTeamName);
          } else {
            console.log("실패", responseResultDescription);
          }
        }).catch(err => console.log(err));
  }


  return (
      <div className="w-full h-full flex flex-col justify-center bg-white overflow-y-auto"
      >
        <ModalHandler initModalHandle={OpenModal}/>

        {/*버튼영역*/}
        <div
            className="flex flex-row w-full whitespace-nowrap overflow-scroll [&::-webkit-scrollbar]:hidden py-3 pl-0.5 z-10"
            style={{
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
            ref={buttonContainerRef} // 버튼 컨테이너에 ref 연결
        >
          {buttonList?.map((button) => {
            return (
                <button
                    key={button.name}
                    className={neverLandUtils.classNames(button.name === selectedButton.name ? "bg-amber-400" : "bg-white ring-1 ring-gray-300 shadow-md", "px-3 py-1 mr-2 rounded-lg")}
                    onClick={() => setSelectedButton(button)}
                >
                  {button.name}
                </button>
            );
          })}
        </div>

        <div className="w-full"
             onTouchStart={handleTouchStart}
             onTouchMove={handleTouchMove}
            // onTouchEnd={handleTouchEnd}
        >
          {buttonList.length === 0 &&
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-stone-600 text-xl whitespace-nowrap">
                <p>경기정보를 수집 하는 중입니다.</p>
                <p>업데이트 예정입니다.</p>
              </div>
          }

          {selectedButton && selectedButton.name === "예상 라인업" &&
              <LineupComponent dataId={gameId}
                               analysisType={analysisType}
              />
          }

          {selectedButton && selectedButton.name === "최근전적" &&
              <RecentlyRecordeComponent dataId={gameId}
                                        analysisType={analysisType}
              />
          }

          {selectedButton && selectedButton.name === "전력분석" && (
              analysisType === 'lineup' ? ( // 금장
                  <StrengthAnalysisComponent dataId={gameId} analysisType={analysisType}/>
              ) : analysisType === 'report' ? ( // 은장
                  <StrengthAnalysisComponentFromReport dataId={gameId} analysisType={analysisType}/>
              ) : null
          )}


          {selectedButton && selectedButton.name === "상대전적" &&
              <OpponentRecordeComponent dataId={gameId}
                                        analysisType={analysisType}
              />
          }

          {selectedButton && selectedButton.name === "배당률" &&
              <RateComponent dataId={gameId}
                             analysisType={analysisType}
              />
          }

          {selectedButton && selectedButton.name === "순위" && (
              analysisType === 'lineup' ? ( // 금장
                  <RankingTable dataId={gameId} analysisType={analysisType}/>
              ) : analysisType === 'report' ? ( // 은장
                  <RankingTableFromReport dataId={gameId} analysisType={analysisType}/>
              ) : null
          )}

          {selectedButton && selectedButton.name === "그래프" &&
              <PointGraph dataId={gameId}
                          analysisType={analysisType}
              />
          }

        </div>
      </div>
  );
}

export default GameAnalysisPage;

